import React from 'react';

import { classNamer, classes } from '../../lib/utils';
import { dateDisplay, userDisplayName } from '../../lib/selectors';
import * as PropTypes from 'prop-types';

import './Details.scss';

const cn = classNamer('Details');

const Details = ({ item, className }) => {
  if (!item) {
    return null;
  }

  const hasAuthor = !!item.posted_by;

  if (!item.published_at) return null;

  return (
    <div className={classes(cn(), className)}>
      <span className={cn('published')}>{dateDisplay(item.published_at)}</span>
      {hasAuthor && <span className={cn('splitter')}>⸫</span>}
      {hasAuthor && <span className={cn('posted')}>by {userDisplayName(item.posted_by)}</span>}
    </div>
  );
};

Details.propTypes = {
  item: PropTypes.object,
};

export default Details;
